const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const isProduction = process.env.NODE_ENV === 'production';

let analyticsInitialized = false;

const injectGtagScript = () => {
  if (document.getElementById('ga-gtag')) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'ga-gtag';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const initAnalytics = () => {
  if (!GA_MEASUREMENT_ID) {
    if (!isProduction) {
      console.warn('Google Analytics not initialized: REACT_APP_GA_MEASUREMENT_ID is missing.');
    }
    return;
  }

  if (analyticsInitialized) {
    return;
  }

  injectGtagScript();

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false, // SPA: we send page_view manually on route changes
    transport_type: 'beacon',
    debug_mode: !isProduction,
  });

  analyticsInitialized = true;
};

export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;

  window.gtag('event', eventName, params);
};

export const updateAnalyticsConsent = (granted) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;

  window.gtag('consent', 'update', {
    ad_storage: granted ? 'granted' : 'denied',
    analytics_storage: granted ? 'granted' : 'denied',
  });
};
